<div *transloco="let t" class="col grid-item">
  <div class="event-card position-relative">
    <div class="image-wrapper">
      <div class="race-sport-wrapper">
        <span class="race-date-wrapper__month text-uppercase pe-2"
          [innerHTML]="eventItem && eventItem.start ? formatDate(eventItem!.start) : ''"></span>
        <span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'d') : ''"></span>
        -
        <span [innerHTML]="eventItem && eventItem.end ? (eventItem!.end | date:'d') : ''"></span>
        <span>.</span>
        <span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'yyyy') : ''"></span>
      </div>
      <div class="position-relative image-box">
        @if(eventItem?.imageMedium !== null){
        <img src="{{eventItem!.imageMedium}}" alt="" class="bck-img" appImageFallback>
        }
        @if(eventItem?.imageMedium === null){
        <img src="{{environment.assetsImagesPath + '/assets/img/hiker.png'}}" alt="" class="bck-img" appImageFallback>
        }
        <div class="img-overlay"></div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="title-wrapper">
        <span class="title-wrapper__title mb-0 trim-text-second-line pe-3">
          <app-language-output [hrLabel]="eventItem?.name" [srLabel]="eventItem?.nameSr" [enLabel]="eventItem?.nameEng" [itLabel]="eventItem?.nameIta" [bsLabel]="eventItem?.nameBs"
            [siLabel]="eventItem?.nameSlo" [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages" />
        </span>
        <div class="title-wrapper__location">
          @if(eventItem?.city || eventItem?.country){
          <img src="assets/icons/location-icon.svg" alt="Running" class="card-body__icon" />
          }
          <div class="title-wrapper__location-text">
            <span>{{ validCityAndCountry(eventCountry?.name,eventItem?.city)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="event-card__distance d-flex align-items-stretch">
      <div class="events-count-wrapper d-flex align-items-center flex-grow-1">
        <img src="assets/icons/location-icon-alt.svg" alt="Running"
          class="card-body__icon card-body__icon--distance me-2" />
        @for(length of eventItem?.lengths;track length){
        <span>
          {{ length | raceLengthFormat:translocoService.getActiveLang() }}
        </span>
        @if(eventItem?.lengths &&
        eventItem!.lengths!.indexOf(length) < eventItem!.lengths!.length-1){ <span
          class="race-length-wrapper__separator">|</span>
          }
          }
      </div>
      <div class="heart-icon-wrapper d-flex align-items-center justify-content-center">
        @if(isOnWishList){
          <img src="assets/icons/red-heart.svg" alt="Heart" (click)="addToFavoritesButtonClicked($event,eventItem)" />
        }@else {
          <img src="assets/icons/red-outlined-heart.svg" alt="Heart"
            (click)="addToFavoritesButtonClicked($event,eventItem)" />
        }
      </div>
    </div>
  </div>
</div>
